<label tuiProgressLabel>
  <span class="text">{{ value }} of {{ max }}</span>

  <tui-progress-circle
    [value]="value"
    [max]="max"
    [size]="size"
    [color]="color"
  ></tui-progress-circle>
</label>
